const r = {
  "cdr-filmstrip": "cdr-filmstrip_15-6-1-beta-4",
  "cdr-filmstrip__viewport": "cdr-filmstrip__viewport_15-6-1-beta-4",
  "cdr-filmstrip__root": "cdr-filmstrip__root_15-6-1-beta-4",
  "cdr-filmstrip__frames": "cdr-filmstrip__frames_15-6-1-beta-4",
  "cdr-filmstrip__frame": "cdr-filmstrip__frame_15-6-1-beta-4",
  "cdr-filmstrip__bar": "cdr-filmstrip__bar_15-6-1-beta-4",
  "cdr-filmstrip__bar--horizontal": "cdr-filmstrip__bar--horizontal_15-6-1-beta-4",
  "cdr-filmstrip__thumb": "cdr-filmstrip__thumb_15-6-1-beta-4",
  "cdr-filmstrip__arrow": "cdr-filmstrip__arrow_15-6-1-beta-4",
  "cdr-filmstrip__arrow--left": "cdr-filmstrip__arrow--left_15-6-1-beta-4",
  "cdr-filmstrip__arrow--right": "cdr-filmstrip__arrow--right_15-6-1-beta-4",
  "cdr-filmstrip__sr-only": "cdr-filmstrip__sr-only_15-6-1-beta-4"
};
export {
  r as default
};
